import { render, staticRenderFns } from "./Stream.vue?vue&type=template&id=5040dea4&scoped=true&"
import script from "./Stream.vue?vue&type=script&lang=js&"
export * from "./Stream.vue?vue&type=script&lang=js&"
import style0 from "./Stream.vue?vue&type=style&index=0&id=5040dea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040dea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VResponsive,VRow})
